<template>
  <section class="section">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("woo commerce module settings") }}
      </h1>
    </div>

    <div class="container mt-6">
      <div class="title is-5">
        {{ $t("woo commerce configuration") }}
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("api url domain") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.api_url"
                placeholder="https://gomodul.com"
              />
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("consumer key") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.consumer_key" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("consumer secret") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.consumer_secret" />
            </div>
          </div>
        </div>
      </div>
      <div class="title is-5">
        {{ $t("synch dates") }}
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("last order synch date") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.last_synch_date"
                placeholder="YYYY-MM-DDTHH:MM:SS"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("last product synch date") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.last_product_synch_date"
                placeholder="YYYY-MM-DDTHH:MM:SS"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-5">
      <div class="columns">
        <div class="column">
          <h1 class="title is-5">{{ $t("fel integration") }}</h1>
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_integrate_fel"
              v-model="meta.integrate_fel"
            />
            <label for="chk_integrate_fel">{{ $t("integrate fel") }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('fel emitter')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/fel/emitter/catalog"
              name_field="name"
              value_field="emitter_id"
              @selected="set_fel_emitter"
              ref="fel_emitter_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default country") }}</label>
            <input
              type="text"
              class="input"
              v-model="meta.fel_default_country"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default department") }}</label>
            <input
              type="text"
              class="input"
              v-model="meta.fel_default_department"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default municipality") }}</label>
            <input
              type="text"
              class="input"
              v-model="meta.fel_default_municipality"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default zip code") }}</label>
            <input
              type="text"
              class="input"
              v-model="meta.fel_default_zip_code"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_send_bill_over_email"
              v-model="meta.send_billing_over_email"
            />
            <label for="chk_send_bill_over_email">{{
              $t("send bill over email")
            }}</label>
          </div>
          <div class="field">
            <generic-dropdown
              :title="$t('billing email template')"
              :placeholder="$t('template')"
              :is_multiple="false"
              url="/outbox/template/catalog"
              name_field="name"
              value_field="template_id"
              @selected="set_billing_template"
              ref="billing_template_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <h1 class="title is-5">{{ $t("inventory integration") }}</h1>
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_integrate_inventory"
              v-model="meta.integrate_inventory"
            />
            <label for="chk_integrate_inventory">{{
              $t("integrate inventory")
            }}</label>
          </div>
          <div class="field">
            <generic-dropdown
              :title="$t('movement type to apply on sale')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/inventory/movement_type/catalog"
              name_field="name"
              value_field="movement_type_id"
              @selected="set_movement_type"
              ref="movement_type_dropdown"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
// import ProviderModal from "./emitters_datatable/provider_modal/Index.vue";

export default {
  name: "WooCommerceSettings",
  components: {
    GenericDropdown,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    // add_provider() {
    //   let v = this;
    //   v.meta.providers.push({ name: "" });
    // },
    // configure_provider(provider) {
    //   let v = this;
    //   v.$refs.provider_modal.show_modal(provider);
    // },
    provider_configured(data) {
      console.log("provider_configured", data);
    },
    set_fel_emitter(emitter) {
      let v = this;
      v.meta.fel_emitter_id = emitter.emitter_id;
    },
    set_billing_template(template) {
      let v = this;
      v.meta.billing_template_id = template.template_id;
    },
    set_movement_type(movement_type) {
      let v = this;
      v.meta.inventory_movement_type_id = movement_type.movement_type_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) {
          v.meta = conf;
          if (conf.fel_emitter_id)
            v.$refs.fel_emitter_dropdown.set_value(conf.fel_emitter_id);
          if (conf.billing_template_id)
            v.$refs.billing_template_dropdown.set_value(
              conf.billing_template_id
            );
          if (conf.inventory_movement_type_id)
            v.$refs.movement_type_dropdown.set_value(
              conf.inventory_movement_type_id
            );
        }
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
